import { useMemo } from "react";
export const useEnvConfig = () => {
    return useMemo(() => window.__ENV_CONFIG, []);
};
//# sourceMappingURL=useEnvConfig.js.map